export enum ALERTS_MODAL_CONSTANTS {
	STATUS,
	DISPLAY_TYPE,
}
